export type DeliveryPreferenceValues = {
  office: string | null;
  floor: string | null;
  deliveryDetails: string;
  displayedWorks: string;
};

export const getDeliveryPreferenceDefaults = (): DeliveryPreferenceValues => ({
  office: null,
  floor: null,
  deliveryDetails: "",
  displayedWorks: "",
});
